// Retrieve Tickets
export const GET_PROCURING_ENTITIES_START = "GET_PROCURING_ENTITIES_START";
export const GET_PROCURING_ENTITIES_SUCCESS = "GET_PROCURING_ENTITIES_SUCCESS";
export const GET_PROCURING_ENTITIES_FAILURE = "GET_PROCURING_ENTITIES_FAILURE";

export const CREATE_PROCURING_ENTITY_START = "CREATE_PROCURING_ENTITY_START";
export const CREATE_PROCURING_ENTITY_SUCCESS = "CREATE_PROCURING_ENTITY_SUCCESS";
export const CREATE_PROCURING_ENTITY_FAILURE = "CREATE_PROCURING_ENTITY_FAILURE";

export const DELETE_PROCURING_ENTITY_START = 'DELETE_PROCURING_ENTITY_START';
export const DELETE_PROCURING_ENTITY_SUCCESS = 'DELETE_PROCURING_ENTITY_SUCCESS';
export const DELETE_PROCURING_ENTITY_FAILURE = 'DELETE_PROCURING_ENTITY_FAILURE';

export const SELECT_PROCURING_ENTITY = 'SELECT_PROCURING_ENTITY';

export const OPEN_PROCURING_ENTITY = 'OPEN_PROCURING_ENTITY';
export const CLOSE_PROCURING_ENTITY = 'CLOSE_PROCURING_ENTITY';

export const UPDATE_PROCURING_ENTITY_START = 'UPDATE_PROCURING_ENTITY_START';
export const UPDATE_PROCURING_ENTITY_SUCCESS = 'UPDATE_PROCURING_ENTITY_SUCCESS';
export const UPDATE_PROCURING_ENTITY_FAILURE = 'UPDATE_PROCURING_ENTITY_FAILURE';

export const GET_ACTORS_START = 'GET_ACTORS_START';
export const GET_ACTORS_SUCCESS = 'GET_ACTORS_SUCCESS';
export const GET_ACTORS_FAILURE = 'GET_ACTORS_FAILURE';

export const GET_PROCURING_ENTITY_START = 'GET_PROCURING_ENTITY_START';
export const GET_PROCURING_ENTITY_SUCCESS = 'GET_PROCURING_ENTITY_SUCCESS';
export const GET_PROCURING_ENTITY_FAILURE = 'GET_PROCURING_ENTITY_FAILURE';

export const SEARCH_PROCURING_ENTITY = "SEARCH_PROCURING_ENTITY"

// Retrieve Package
export const GET_PACKAGES_START = "GET_PACKAGES_START";
export const GET_PACKAGES_SUCCESS = "GET_PACKAGES_SUCCESS";
export const GET_PACKAGES_FAILURE = "GET_PACKAGES_FAILURE";

export const GET_PACKAGE_START = "GET_PACKAGE_START";
export const GET_PACKAGE_SUCCESS = "GET_PACKAGE_SUCCESS";
export const GET_PACKAGE_FAILURE = "GET_PACKAGE_FAILURE";

export const DELETE_PACKAGES_START = 'DELETE_PACKAGES_START';
export const DELETE_PACKAGES_SUCCESS = 'DELETE_PACKAGES_SUCCESS';
export const DELETE_PACKAGES_FAILURE = 'DELETE_PACKAGES_FAILURE';

export const SELECT_PACKAGE = 'SELECT_PACKAGE';

export const OPEN_PACKAGE = 'OPEN_PACKAGE';
export const CLOSE_PACKAGE = 'CLOSE_PACKAGE';

export const CREATE_PACKAGE_START = "CREATE_PACKAGE_START";
export const CREATE_PACKAGE_SUCCESS = "CREATE_PACKAGE_SUCCESS";
export const CREATE_PACKAGE_FAILURE = "CREATE_PACKAGE_FAILURE";

export const UPDATE_PACKAGE_START = 'UPDATE_PACKAGE_START';
export const UPDATE_PACKAGE_SUCCESS = 'UPDATE_PACKAGE_SUCCESS';
export const UPDATE_PACKAGE_FAILURE = 'UPDATE_PACKAGE_FAILURE';
